import { Stack, ToggleButton } from "@mui/material"
import { useState, useEffect } from "react"
import {
  preview,
  treatView,
  viewControlInTreatment,
  wasmModule,
} from "@/gluelayer"
import { useTheme } from "@mui/material/styles"
import { useAppDispatch,useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import ZoomInIcon from "../assets/toptoolbar/zoomin.svg"
import ZoomOutIcon from "../assets/toptoolbar/zoomout.svg"
import { ReactSVG } from "react-svg"


import {
  setZoomBarValue,
} from "./../udTreatSlice"


export const ZoomBar = ({ sx = {} }) => {
  const theme = useTheme()
  const dispatch = useAppDispatch()

  const options = [100, 200, 400]


  const { ZoomBarValue } = useAppSelector(
      (state: RootState) => state.udTreatService,
  )

  const {
    hasUploadSTLs,
    curCaseMode,
    openHistorySplitView,
    isCreateNewRefinement,
    currentTreatmentPlan,
    openOrderSplit,
    zoomDisabled,
  } = useAppSelector((state: RootState) => state.udTreatService)

  useEffect(() => {
    if (!wasmModule.isFinishedOpencase) return
    dispatch(setZoomBarValue(100))
    console.log(
      "🚀 ~ useEffect ~ isCreateNewRefinement:",
      isCreateNewRefinement,
    )

    if (openHistorySplitView || isCreateNewRefinement) {
      treatView.SetUpdateSliderCB((zoomvalue) => {
        dispatch(setZoomBarValue(Math.round(zoomvalue * 100)))
      })
    } else {
      viewControlInTreatment.setZoomCallbackInTreatment((curZoomVal) => {
        //   console.log("cur zoom value", Math.round(curZoomVal * 100))
        dispatch(setZoomBarValue(Math.round(curZoomVal * 100)))
      })
    }
  }, [openHistorySplitView, isCreateNewRefinement, currentTreatmentPlan])

  useEffect(() => {
    dispatch(setZoomBarValue(100))
  }, [openOrderSplit])

  useEffect(() => {
    if (preview.isInitPreview()) {
      preview.zoomWithValue(ZoomBarValue / 100)
    }
    if (!wasmModule.isFinishedOpencase || !ZoomBarValue) return

    if (openHistorySplitView || isCreateNewRefinement)
      wasmModule.treatView.ZoomAutomatic(ZoomBarValue / 100)
    else viewControlInTreatment.zoomWithValueInTreatment(ZoomBarValue / 100)
  }, [ZoomBarValue])
  const handleSelectChange = (event) => {
    dispatch(setZoomBarValue(event.target.value))
  }

  useEffect(() => {
    if (!wasmModule.isFinishedOpencase) return
    viewControlInTreatment.setZoomCallbackInTreatment((curZoomVal) => {
      dispatch(setZoomBarValue(Math.round(curZoomVal * 100)))
    })
  }, [wasmModule.isFinishedOpencase])

  useEffect(() => {
    if (!wasmModule.isFinishedOpencase && preview.isInitPreview()) {
      preview.setZoomCallback((curZoomVal) => {
        dispatch(setZoomBarValue(Math.round(curZoomVal * 100)))
      })
    }
  }, [hasUploadSTLs])

  const handlePlusOrMin = (num) => {
    let newZoomValue = ZoomBarValue + num
    newZoomValue = Math.min(Math.max(newZoomValue, 25), 400)
    dispatch(setZoomBarValue(newZoomValue))
  }

  const checkShowZoomBar = () => {
    if (curCaseMode === "NewCase") {
      if (hasUploadSTLs[0] || hasUploadSTLs[1]) return true
      else return false
    } else return true
  }
  return (
    checkShowZoomBar() && (
      <Stack
        sx={{
          height: 48,
          borderRadius: 2,
          backgroundColor: zoomDisabled
            ? "lightgray"
            : theme.transBkColor.light,
          boxShadow: 3,
          zIndex: 20,
          ...sx,
        }}
        direction={"row"}
      >
        <ToggleButton
          disabled={zoomDisabled}
          value={0}
          sx={{
            border: "none",
            borderRadius: "8px",
            "&:hover": {
              borderRadius: "8px",
            },
            "&.Mui-selected": {
              borderRadius: "8px",
            },
            ":disabled": {
              border: "none",
            },
          }}
          onClick={() => handlePlusOrMin(-10)}
        >
          <ReactSVG src={ZoomOutIcon} style={{ marginTop: 6 }}></ReactSVG>
        </ToggleButton>
        {/* <FormControl
          variant="outlined"
          sx={{
            m: 1,
            minWidth: 100,
            position: "relative", // 添加相对定位
          }}
        >
          <Select
            sx={{ height: 35 }}
            value={""}
            label=""
            onChange={handleSelectChange}
            //   displayEmpty
          >
            {options.map((option, index) => (
              <MenuItem key={index} value={option}>
                {option + "%"}
              </MenuItem>
            ))}
          </Select>
          <Typography
            sx={{
              position: "absolute",
              height: 20,
              top: 5,
              left: 15,
            }}
          >
            {value + "%"}
          </Typography>
        </FormControl> */}
        <ToggleButton
          disabled={zoomDisabled}
          value={1}
          sx={{
            border: "none",
            borderRadius: "8px",
            "&:hover": {
              borderRadius: "8px",
            },
            "&.Mui-selected": {
              borderRadius: "8px",
            },
            ":disabled": {
              border: "none",
              backgroundColor: "lightgray",
            },
          }}
          onClick={() => handlePlusOrMin(10)}
        >
          <ReactSVG src={ZoomInIcon} style={{ marginTop: 6 }}></ReactSVG>
        </ToggleButton>
      </Stack>
    )
  )
}
